import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { VerificationService } from '../../../Model/Verification/verification.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-bank-kyc',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './bank-kyc.component.html',
  styleUrl: './bank-kyc.component.scss'
})
export class BankKYCComponent {
  isDisabled: boolean = false;
  Banks = [] as any;
  @Input() EmpMasterId: number = 0;
  @Input() EmpType: String = '';
  BankDetail = {
    BankId: null as any,
    BankName: null,
    BankAccountNo: null,
    BankAccountNoStar: null,
    IFSCode: null,
    NameAsPerBank: null,
    BankVerificationID: null,
    BankVerificationStatus: null as any,
    AccountLength: null
  }

  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private verification: VerificationService,
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    protected combo: ComboService,
  ) { }

  ngOnInit(): void {
    this.ComboLoad('Bank')
  }

  Verification(form: any) {
    if (form.valid) {
      if (this.BankDetail.BankAccountNo == this.BankDetail.BankAccountNoStar) {
        this.isDisabled = true;
        this.PanAadharBankDuplicate('CheckBankAcc', this.BankDetail.BankAccountNo);
      }else{
        this.toast.show({message:'Account no and confirm account no mismatch',type:toastTypeEnum.warning});
      }

    } else {
      form.submitted = true;
    }
  }

  Confirm() {
    this.BankDetail.BankName = this.Banks.filter((e: any) => e.bank_master_id == this.BankDetail.BankId)[0]['bank_name'];
    this.activeModal.close(this.BankDetail);
  }

  PanAadharBankDuplicate(SelectType: any, CheckValue: any) {
    this.isDisabled = true;
    this.employeeRegistration.PanAadharBankDuplicate({ CheckCompanyWise: true, SelectType: SelectType, FormType: this.EmpType, CheckValue: CheckValue, EmpMasterID: this.EmpMasterId }).subscribe({
      next: (response2) => {
        if (response2.Error_Code == '0') {
          if (SelectType == 'CheckBankAcc') {
            this.verification.VerifyBank({ 'AccNo': this.BankDetail.BankAccountNo, 'IFSC': this.BankDetail.IFSCode }).subscribe({
              next: (response) => {
                this.SaveVerification('Bank Details', this.BankDetail.BankAccountNo + ' - ' + this.BankDetail.IFSCode, JSON.stringify(response), response.response_code == 100 ? true : false);
                if (response.transaction_status == 1) {
                  this.BankDetail.NameAsPerBank = response.data.BeneName;
                } else {
                  this.toast.show({ message: response.response_message, type: toastTypeEnum.warning });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: response2.Error_Message, type: toastTypeEnum.warning });
          this.isDisabled = false;
        }

      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
        return "";
      },
    });
  }

  SaveVerification(mVerificationType: string, mRequest: any, mResponse: any, Store: any) {
    this.employeeRegistration.SaveVerification({ mVerificationType: mVerificationType, mRequest: mRequest, mResponse: mResponse, EmpMasterId: this.EmpMasterId }).subscribe({
      next: (response) => {
        if (mVerificationType == 'Bank Details' && Store) {
          this.BankDetail.BankVerificationID = response.mVerificationID;
          this.BankDetail.BankVerificationStatus = 'Verified';
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': 0, 'DistrictId': 0, 'EmpMasterID': 0 }).subscribe({
      next: (response) => {
        if (Combotype == 'Bank') {
          this.Banks = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetIFSCCode() {
    this.BankDetail.BankAccountNo = null;
    this.BankDetail.BankAccountNoStar = null;
    this.BankDetail.IFSCode = null;
    this.BankDetail.NameAsPerBank = null;
    this.BankDetail.BankVerificationID = null;
    this.BankDetail.BankVerificationStatus = null;
    this.BankDetail.AccountLength = null;

    this.BankDetail.IFSCode = this.Banks.filter((e: any) => e.bank_master_id == this.BankDetail.BankId)[0]['DefaultIFSCCode'];
    this.BankDetail.AccountLength = this.Banks.filter((e: any) => e.bank_master_id == this.BankDetail.BankId)[0]['AcNoLength'];
  }

  ClearAccountNo(){
    if(this.BankDetail.BankAccountNo != null){
      this.BankDetail.BankAccountNo = null;
    }
  }

  close() {
    this.activeModal.close();
  }
}
